import React from 'react';

import cn from 'classnames';

import st from './shared.module.sass';

export function Section({ rootProps = {}, title, children, className }) {
  const { id, ...rest } = rootProps;

  return (
    <section className={cn(st.Section, className)} id={id} {...rest}>
      {title && (
        <div className={st.Section__Title}>
          <h6>{title}</h6>
        </div>
      )}
      {children}
    </section>
  );
}
